import { injectable, inject } from 'inversify';
import type { IAuthRepository } from '@/domain/repositories/IAuthRepository';
import { ChangeUserTenantCommand } from '@/application/commands/auth/ChangeUserTenantCommand';
import { TYPES } from '@/di/tokens';

@injectable()
export class ChangeUserTenantAction {
  constructor(
    @inject(TYPES.IAuthRepository) private authRepository: IAuthRepository
  ) {}

  async execute(command: ChangeUserTenantCommand): Promise<void> {
    // El repositorio ya actualiza el localStorage con el usuario actualizado del backend
    await this.authRepository.changeUserTenant(command.tenantId);
  }
}
